import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { RenaultManagerUserService } from '../../services/renault-manager-user.service';

@Component({
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    RouterOutlet
  ],
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  
  //readonly layoutMode: AdminLayoutMode = environment.adminLayoutMode ?? 'sidebar';
  readonly layoutMode = 'sidebar';
  //readonly useHorizontalNav = this.layoutMode === 'horizontal';
  readonly useHorizontalNav = false;

  private readonly auth = inject(AuthService);  
  protected readonly isLoggedIn = toSignal(this.auth.isLoggedIn$, { initialValue: false });  
  protected readonly userService = inject(RenaultManagerUserService);

  defaultPageTitle = 'Concesionarios';
  pageTitle: string = this.defaultPageTitle;
  appName = 'Administrador RENAULT';
  isSidebarCollapsed = false;
  menuState: Record<string, boolean> = {};
  private routerSubscription?: Subscription;
  private readonly collapseBreakpoint = 767.98;
  private readonly menuRoutePrefixes = {
    'admin': ['/admin']
  };

  private readonly pageTitles = [
    { prefix: '/admin/distributor', title: 'Concesionarios' },
    { prefix: '/admin/api-client', title: 'Clientes / API' }
  ];

  readonly menuItems: any[] = [
    { label: 'Concesionarios', route: '/admin/distributor', iconClass: 'bi bi-file-earmark-text' },
    { label: 'Clientes / API', route: '/admin/api-client', iconClass: 'bi bi-braces-asterisk' }
  ];

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.userService.updateLastLoginDate().subscribe();
  }

  ngOnInit(): void {
    if (!this.useHorizontalNav) {
      this.isSidebarCollapsed = window.innerWidth <= this.collapseBreakpoint;
    }
    this.syncMenusWithRoute(this.router.url);
    this.updatePageTitle(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => {
        this.syncMenusWithRoute(event.urlAfterRedirects);
        this.updatePageTitle(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }

  protected get displayName(): string | null {
    return this.auth.displayName;
  }

  protected login(): void {
    this.auth.login();
  }

  protected logout(): void {
    this.auth.logout();
  }

  toggleSidebar(): void {
    if (this.useHorizontalNav) {
      return;
    }
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  toggleMenu(key: string): void {
    const submenu: HTMLElement = document.querySelector(`[data-ap-parent="${key}"]`);
    if (submenu) {
      let maxHeight = 0;
      const links = submenu.querySelectorAll('.nav-link');
      links.forEach((link: HTMLElement) => {
        maxHeight += link.offsetHeight;
      });
      submenu.style.maxHeight = `${maxHeight}px`;
    }
    this.menuState[key] = !this.isMenuOpen(key);

    if (!this.menuState[key]) {
      submenu.style.maxHeight = '0';
    }
  }

  isMenuOpen(key: string): boolean {
    return Boolean(this.menuState[key]);
  }

  private syncMenusWithRoute(url: string): void {
    let hasOpenMenu = false;
    for (const key of Object.keys(this.menuRoutePrefixes)) {
      const isOpen = this.menuRoutePrefixes[key].some(prefix => url.startsWith(prefix));
      this.menuState[key] = isOpen;
      // console.log(key, isOpen);
      if (isOpen) {
        hasOpenMenu = true;
        break;
      }
    }
    if (!hasOpenMenu) {
      this.menuState['home'] = true;
    }
  }

  private updatePageTitle(url: string): void {
    const match = this.pageTitles.find(item => url.startsWith(item.prefix));
    this.pageTitle = match ? match.title : this.defaultPageTitle;    
    document.title = `${this.appName} - ${this.pageTitle}`;

    this.cdr.detectChanges();
  }
}

